import { render, staticRenderFns } from "./textButton.vue?vue&type=template&id=1086f2cc&scoped=true&"
import script from "./textButton.vue?vue&type=script&lang=js&"
export * from "./textButton.vue?vue&type=script&lang=js&"
import style0 from "./textButton.vue?vue&type=style&index=0&id=1086f2cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1086f2cc",
  null
  
)

export default component.exports